

/**
 * Preview frame sizing for **template library** cards (9:16 portrait capped at 220px width).
 * Campaign **grid** cards (/campaigns) use a fixed 200px band — see CampaignCard.js (not this module).
 */

/** Template library preview band (slightly taller). */
export const TEMPLATE_CARD_PREVIEW_MIN_HEIGHT_PX = 208;

const PORTRAIT_MAX_WIDTH_PX = 220;
const SQUARE_MAX_WIDTH_PX = 300;

/**
 * @param {string|undefined} aspectRatio
 * @returns {string}
 */
export function getAspectPreviewClass(aspectRatio) {
  const value = String(aspectRatio || '16:9').trim();
  if (value === '9:16') return 'ratio';
  if (value === '1:1') return 'ratio ratio-1x1';
  return 'ratio ratio-16x9';
}

/**
 * Bootstrap ratio override for 9:16 portrait.
 * @param {string|undefined} aspectRatio
 * @returns {Record<string, string>|undefined}
 */
export function getAspectPreviewStyle(aspectRatio) {
  if (String(aspectRatio || '').trim() === '9:16') {
    return { '--bs-aspect-ratio': '177.7778%' };
  }
  return undefined;
}

/**
 * Keeps portrait/square previews from stretching to full grid column width.
 * @param {string|undefined} aspectRatio
 * @returns {Record<string, string>|undefined}
 */
export function getAspectFrameWrapStyle(aspectRatio) {
  const value = String(aspectRatio || '16:9').trim();
  if (value === '9:16') {
    return {
      maxWidth: `${PORTRAIT_MAX_WIDTH_PX}px`,
      margin: '0 auto',
      width: '100%',
    };
  }
  if (value === '1:1') {
    return {
      maxWidth: `${SQUARE_MAX_WIDTH_PX}px`,
      margin: '0 auto',
      width: '100%',
    };
  }
  return { width: '100%' };
}
